<table class="table table-borderless table-striped table-hover">
  <thead>
    <tr>
      <th translate>FILE</th>
      <th translate>UPDATED_BY</th>
      <th translate>UPDATED_AT</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let element of data">
      <td>
        <a (click)="downloadDocument(element)">
          <span translate>{{ element.name }}</span>
        </a>
      </td>
      <td>{{ element.updatedBy }}</td>
      <td>{{ element.updatedAt | date: 'yyyy-MM-dd' }}</td>
      <td>
        <button type="button" class="btn btn-danger" (click)="deleteDocument(element)">
          <i class="fa-solid fa-trash-can"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>
<div class="mt-3 mb-2">
  <label for="file-input" class="label-file btn btn-secondary">
    <i class="fa-regular fa-upload mx-1"></i><span translate>UPLOAD</span>
  </label>
  <input type="file" id="file-input" (change)="uploadDocument($event)" style="opacity: 0" />
</div>